import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import css from './TicketExpiration.module.scss';

interface Props {
  className?: string;
  expiration: number;
}

const TicketExpiration = (props: Props) => {
  const intl = useIntl();
  // 6ヶ月の場合は180日固定（資金決済法に抵触するため）となっているので日数を明確に表示
  // それ以外のものに関しては厳密に月数を計算しているので日数表示をさせない
  const translationId =
    props.expiration === 6
      ? 'merchants.common.ticketExpirationWithDays.unit'
      : 'merchants.common.ticketExpiration.unit';

  return (
    <span className={classNames(css.TicketExpiration, props.className)}>
      <span className={css.TicketExpiration__Emphasis}>{props.expiration}</span>
      {intl.formatMessage(
        {
          id: translationId,
        },
        {
          days: props.expiration * 30, // https://github.com/heyinc/rsv-issues/issues/9140
        },
      )}
    </span>
  );
};

export default TicketExpiration;
